import React, {createRef} from 'react';
// import {Animated, Easing} from 'react-native';
import {ColorTheme, ColorUIChecker3, ColorWhite} from 'src/styles/Colors';
// import {ELEVATION} from 'app/src/constants/Styles';
import utils from 'src/js/utils/utils';
import AppIcon from 'src/js/components/commons/AppIcon';
import AppImage from 'src/js/components/commons/AppImage';
import {RadiusView} from 'src/res/Radius';
import {HeightElementMinimum, SpaceSmall, SpaceXSmall} from 'src/res/Spacing';
import AppTextWrapper from 'src/js/components/commons/AppTextWrapper';
import {FontWeightMedium} from 'src/res/FontWeight';
import {logDebug} from "../../utils/AppLog";
import AppImageButtonEx from "../commons/AppImageButtonEx";
import {Button} from "@material-ui/core";
import {locString} from "../commons/ViewHelper";
import View from "../commons/View";
import TouchableOpacity from "../commons/TouchableOpacity";
import ImageBackground from "../commons/ImageBackground";
import CircularProgress from "@material-ui/core/CircularProgress";
import {animated, easings, SpringValue} from '@react-spring/web';
import FocusHelperView from "../commons/FocusHelperView";
import GameAudio from "../commons/GameAudio";
import {GAME_LOSE_AUDIO, GAME_WIN_AUDIO} from "../../utils/GameAudioPlayer";
import AppText from "../commons/AppText";
import {dispatchSimulationClick} from "src/js/utils/AppUtils";

export const SLOT_GAME_END_DELAY_MS = 1.2 * 1000;
export const SLOT_CARD_MAX_WIDTH = 100;

const ANIMATION_DURATION = 500;
const ANIMATION_DURATION_STOP = 1500;

const ROLL_STOPPING_COUNTER = 3; // roll extra before stopping
const ROWS = 3; // added extra items equal to rows for seamless animation

const GetView = ({item, boxSize, onCardImageClicked, uiConfigs, ...props}) => {
  const cardBgImage = uiConfigs ? uiConfigs.slotCardBgImage : null;
  const padding = 8;
  const onCardImageClickedL = () => {
    onCardImageClicked(item.imageUrl);
  }
  return (
    <View key={item.key} style={{width: boxSize, height: boxSize, padding: padding, position: 'relative'}}>
      {cardBgImage ? <AppImage source={cardBgImage} resizeMode={'fill'} style={{position: 'absolute', left: 3, top: 3, right: 3, bottom: 3, borderRadius: 4}} /> : null}
      <View style={{alignItems: 'center', justifyContent: 'center', borderRadius: RadiusView}}>
        {item.imageUrl ?
          <TouchableOpacity onClick={onCardImageClickedL}>
            <AppImage
              height={boxSize - (2 * padding)}
              width={boxSize - (2 * padding)}
              borderRadius={RadiusView}
              imageUrl={item.imageUrl}
              resizeMode={'contain'}
            />
          </TouchableOpacity>
          : item.icon
            ? <AppIcon icon={item.icon} color={item.color ? item.color : ColorTheme} size={36} />
            : null
        }
      </View>
    </View>
  );
};

const GetAnimatedColumnView = (props) => {
  const {columnItem, animatedValue, boxSize, onCardImageClicked, uiConfigs, marginLeft} = props;
  return (
    <animated.div
      style={{
        marginTop: animatedValue,
      }}>
      {<GetColumnView
        animated={1}
        marginLeft={marginLeft}
        columnItem={columnItem}
        boxSize={boxSize}
        uiConfigs={uiConfigs}
        onCardImageClicked={onCardImageClicked} />}
    </animated.div>
  );
};

const GetColumnView = ({columnItem, boxSize, onCardImageClicked, uiConfigs, marginLeft}) => {
  return (
    <View style={{width: boxSize}}>
      {columnItem.map((item, index) => <GetView key={item.id +''+ index} marginLeft={marginLeft} item={item} boxSize={boxSize} uiConfigs={uiConfigs} onCardImageClicked={onCardImageClicked}/>)}
    </View>
  );
};

const GetSlotViews = (props) => {
  const {columnItems, cardSpacing, reset, animatedValues, boxSize, onCardImageClicked, uiConfigs} = props;

  return (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      {columnItems.map((columnItem, index) => {
        return (
          !reset ?
            <GetAnimatedColumnView
              key={'SlotView'+ index}
              marginLeft={index > 0 ? cardSpacing : 0}
              columnItem={columnItem}
              animatedValue={animatedValues[index]}
              boxSize={boxSize}
              uiConfigs={uiConfigs}
              onCardImageClicked={onCardImageClicked}/>
            : <GetColumnView
              key={'SlotView'+ index}
              marginLeft={index > 0 ? cardSpacing : 0}
              columnItem={columnItem}
              boxSize={boxSize}
              uiConfigs={uiConfigs}
              onCardImageClicked={onCardImageClicked} />
        )
      })}
    </View>
  );
};

const GetSlotBg = (props) => {
    const {horizontalSpacing, uiConfigs, columns} = props;

    let views = [];
    for (let i = 0; i < columns; i++) {
        let marginStart = i > 0 ? (uiConfigs.slotBgSpacing || 0) : 0;
        marginStart *= uiConfigs.sizeFactor;
        views.push(
          <ImageBackground
            key={'ib'+ i}
            source={uiConfigs.gameBgMImage}
            resizeMode="fill"
            style={{display: 'flex', flex: 1, marginLeft: marginStart, borderWidth: 0}}/>
        )
    }
    return (
      <View style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: horizontalSpacing,
          right: horizontalSpacing,
          display: 'flex',
          flexDirection: 'row',
      }}>
          {views}
      </View>
    );
};

export default class JackpotGameView extends React.PureComponent {

    constructor(props) {
        super(props);
        // this.gameAudioPlayer = this.props.gameAudioPlayer;
        this.items = props.items;
        this.columns = props.columns ? props.columns : 3;
        this.rows = props.rows ? props.rows : 3;
        this.processWin = props.processWin;
        this.key = 0;
        this.columnStoppedCounter = 0;
        this.columnItemsLength = 0;

        const animatedValues = [];
        for (let i = 0; i < this.columns; i++) {
            animatedValues.push(new SpringValue(0));
        }
        this.state = {
            ideal: true,
            delay: false,
            reset: false,
            animatedValues: animatedValues,
        };
        this.processItems();

        this.onAppDidFocus = this.onAppDidFocus.bind(this);
        this.onAppDidBlur = this.onAppDidBlur.bind(this);

        this.gamePlayAudioId1 = createRef();
        this.gamePlayAudioId2 = createRef();
        this.gamePlayAudioId3 = createRef();
        this.gamePlayAudioId4 = createRef();
        this.gamePlayAudioIdLose = createRef();
        this.gamePlayAudioIdWin = createRef();
    }

    componentDidMount() {
        window.addEventListener('onAppDidFocus', this.onAppDidFocus);
        window.addEventListener('onAppDidBlur', this.onAppDidBlur);
        this.isAppInFocus = true;

        setTimeout(() => {
            if (this.props.startAt) {
                this.endItems = this.props.startAt;
                let animatedValues = [];
                for (let i = 0; i < this.columns; i++) {
                    const column = i;
                    const index = this.getIndexToStop(this.columnItems[column], column);
                    if (index !== undefined) {
                        animatedValues.push(new SpringValue(-(this.getCardSize() * index)));
                    }
                }
                this.setState({animatedValues: animatedValues});
            }
        });
    }

    componentWillUnmount() {
      window.removeEventListener('onAppDidFocus', this.onAppDidFocus);
      window.removeEventListener('onAppDidBlur', this.onAppDidBlur);
      this.onAppDidBlur();
      this.resetAnimation();

      this.gamePlayAudioId1.current = null;
      this.gamePlayAudioId2.current = null;
      this.gamePlayAudioId3.current = null;
      this.gamePlayAudioId4.current = null;
      this.gamePlayAudioIdLose.current = null;
      this.gamePlayAudioIdWin.current = null;
    }

    simulatePlay() {
      if (this.refSpin) {
        dispatchSimulationClick(this.refSpin);
      }
    }

    resetItems = (items) => {
        this.items = items;
        this.processItems();
        this.reset();
    }

    onAppDidFocus = () => {
        this.isAppInFocus = true;
    };

    onAppDidBlur = () => {
        this.isAppInFocus = false;
        this.stopGamePlayAudio2();
        this.stopGamePlayAudio3();
        this.stopGamePlayAudioAfterStop();
        this.stopGamePlayAudioAfterApi();
        this.stopGamePlayAudioAfterApiFail();
    };

    onImageClicked = (imageUrl) => {
        if (this.state.ideal) {
            this.props.onImageClicked(imageUrl);
        }
    }

    processItems = () => {
        this.columnItems = [];
        this.stoppingCounters = [];
        for (let i = 0; i < this.columns; i++) {
            this.columnItems.push([]);
            let shuffle = false;
            let forwardBy = 0;
            if (this.props.preview) {
                if (i === 0) {
                    forwardBy = -1;
                } else if (i === this.columns - 1) {
                    forwardBy = this.items.length - 2;
                } else {
                    forwardBy = i - 1;
                }
            } else {
                shuffle = true;
            }
            this.processChildItems(this.columnItems[i], forwardBy, shuffle);
            this.stoppingCounters.push(0);
        }
        this.columnItemsLength = this.items.length + ROWS;
    }

    start = () => {
        this.gameStartTime = new Date().getTime();
        this.resetAnimation();
        this.animationColumns = [];
        for (let i = 0; i < this.columns; i++) {
            this.animateColumn(i);
        }
        this.setState({ideal: false});
        this.playGamePlayAudio1();
    }

    stop = ({endValues, isWin}) => {
        // putting a delay in stopping if api response receive fast
        const delayNeeded = 2 * 1000;
        const gameDuration = new Date().getTime() - this.gameStartTime;
        let delay = 0;
        if (gameDuration < delayNeeded) {
            delay = delayNeeded - gameDuration;
        }
        setTimeout(() => {
            for (let i = 0; i < this.columns; i++) {
                this.stoppingCounters[i] = 0;
            }
            this.endItems = endValues;

            this.isWin = isWin;
            setTimeout(() => {
                this.stopGamePlayAudioAfterApi();
            }, ANIMATION_DURATION * 3);
        }, delay);
    }

    reset = () => {
        this.stopGamePlayAudioAfterApiFail();
        this.resetAnimation();
        // this.setState({reset: true}, () => {
          this.setState({ideal: true, reset: false});
        // });
    }

    resetAnimation = () => {
        this.columnStoppedCounter = 0;
        for (let i = 0; i < this.columns; i++) {
            this.stoppingCounters[i] = 0;
        }
        this.endItems = null;
        if (this.animationColumns) {
            this.animationColumns.forEach((animationColumn) => {
                if (animationColumn) {
                    animationColumn.stop();
                    animationColumn.set(0);
                }
            });
            this.animationColumns = null;
        }
    }

    playGamePlayAudio1 = () => {
        if (this.isAppInFocus) {
            if (!this.props.disableAudio) {
                if (this.gamePlayAudioId1.current) {
                    this.shouldPlayAudio2 = true;
                    this.gamePlayAudioId1.current.play(() => {
                        if (this.shouldPlayAudio2) {
                            this.playGamePlayAudio2();
                        }
                    });
                }
            }
        }
    }

    playGamePlayAudio2 = () => {
        if (this.isAppInFocus) {
            if (!this.props.disableAudio) {
                if (this.gamePlayAudioId2.current) {
                    this.gamePlayAudioId2.current.play();
                }
            }
        }
    }

    playGamePlayAudio3 = () => {
        if (this.isAppInFocus) {
            if (!this.props.disableAudio) {
                if (this.gamePlayAudioId3.current) {
                    this.gamePlayAudioId3.current.play();
                }
            }
        }
    }

    playGameEndAudio = (column) => {
        if (this.isAppInFocus) {
            if (!this.props.disableAudio && !this.props.disableEndAudio) {
                if (this.gamePlayAudioId4.current) {
                    this.gamePlayAudioId4.current.play();
                }
            }
        }
    }

    stopGamePlayAudioAfterApiFail = () => {
        this.stopGamePlayAudio2();
        this.stopGamePlayAudio3();
    }

    stopGamePlayAudioAfterApi = () => {
        if (!this.props.gamePlayAudioUrl) {
            this.stopGamePlayAudio2(true);
        }
    }

    stopGamePlayAudioAfterStop = () => {
        if (!this.props.gamePlayAudioUrl) {
            this.stopGamePlayAudio3();
        } else {
            this.stopGamePlayAudio2();
        }
    }

    stopGamePlayAudio2 = (playAudio3OnStop = false) => {
        if (this.gamePlayAudioId2.current) {
            this.shouldPlayAudio2 = false;
            this.gamePlayAudioId2.current.pause(() => {
                if (playAudio3OnStop) {
                    this.playGamePlayAudio3();
                }
            });
        }
    }

    stopGamePlayAudio3 = () => {
        if (this.gamePlayAudioId3.current) {
            this.gamePlayAudioId3.current.pause();
        }
    }

    playGameLoseAudio = () => {
        if (this.isAppInFocus) {
            if (this.gamePlayAudioIdLose.current) {
                this.gamePlayAudioIdLose.current.play();
            }
        }
    }

    playGameWinAudio = () => {
        if (this.isAppInFocus) {
            if (this.gamePlayAudioIdWin.current) {
                this.gamePlayAudioIdWin.current.play();
            }
        }
    }

    render() {
        const {classes, uiConfigs, isLTR} = this.props;
        const boxSize = this.getCardSize();
        const sizeFactor = uiConfigs.sizeFactor;
        const cardSize = this.getCardSize();
        const cardSpacing = this.getCardSpacing();

        const sizeVFactor = uiConfigs.sizeVFactor;
        const spinsLeftText = this.props.spinsLeft > 100 ? ">99" : this.props.spinsLeft == 0 ? locString('no') : this.props.spinsLeft;
        const spinViewHeight = uiConfigs.spinViewHeight * sizeFactor;
        const spinViewWidth = uiConfigs.spinViewWidth * sizeFactor;
        const spinButtonSize = uiConfigs.spinButtonSize * sizeFactor;

        // multi rows
        const marginStartEnd = uiConfigs.slotMarginStartEnd * sizeFactor;
        const marginTop = uiConfigs.slotMarginTop * sizeFactor;
        const marginBottom = uiConfigs.slotMarginBottom * sizeFactor;

        const slotViewWidth = boxSize * this.columns + ((this.columns - 1) * cardSpacing);
        const slotViewHeight = this.rows * boxSize;
        const viewWidth = slotViewWidth + (2 * marginStartEnd);
        const viewHeight = slotViewHeight + marginTop + marginBottom;

        const selectorBorderStartEnd = uiConfigs.slotSelectorBorderStartEndP ? cardSize * uiConfigs.slotSelectorBorderStartEndP/100 : uiConfigs.slotSelectorBorderStartEnd * sizeFactor;
        const selectorBorderTop = uiConfigs.slotSelectorBorderTop * sizeFactor;
        const selectorBorderBottom = uiConfigs.slotSelectorBorderBottom * sizeFactor;
        const selectorViewHeight = boxSize + selectorBorderTop + selectorBorderBottom + 4 - (selectorBorderTop - selectorBorderBottom);
        const selectorViewTop = viewHeight/2 - boxSize/2 - selectorBorderTop - 1;
        const rowsToHide = ROWS - this.rows;
        return (
            <View className={classes.viewColumnFullWidth}>
                {!this.props.disableAudio ?
                  <React.Fragment>
                    <GameAudio ref={this.gamePlayAudioId1} source={'game_slot_1.m4a'} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                    <GameAudio ref={this.gamePlayAudioId2} source={this.props.gamePlayAudioUrl || 'game_slot_2.m4a'} autoPlay={false} loop={true} hasUserInteraction={true} mute={this.props.mute} />
                    <GameAudio ref={this.gamePlayAudioId3} source={'game_slot_3.m4a'} autoPlay={false} loop={true} hasUserInteraction={true} mute={this.props.mute} />
                    <GameAudio ref={this.gamePlayAudioId4} source={'game_slot_4.m4a'} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                    <GameAudio ref={this.gamePlayAudioIdLose} source={this.props.gameLoseAudioUrl || GAME_LOSE_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                    <GameAudio ref={this.gamePlayAudioIdWin} source={this.props.gameWinAudioUrl || GAME_WIN_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                  </React.Fragment>
                  : null
                }
                {uiConfigs ?
                  <View style={{position: 'relative'}}>
                    <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                      {uiConfigs.gameBgImage ? <AppImage resizeMode={'fill'} source={uiConfigs.gameBgImage} style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, height: '100%', width: '100%'}} /> : null}
                      {uiConfigs.gameBgSImage ? <AppImage resizeMode={'fill'} source={uiConfigs.gameBgSImage} style={{position: 'absolute', top: 0, bottom: 0, left: 0, height: '100%', width: Math.ceil(marginStartEnd)}} /> : null}
                      {uiConfigs.gameBgEImage ? <AppImage resizeMode={'fill'} source={uiConfigs.gameBgEImage} style={{position: 'absolute', top: 0, bottom: 0, right: 0, height: '100%', width: Math.ceil(marginStartEnd)}} /> : null}
                    </View>
                    <View style={{height: viewHeight, width: viewWidth, display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: marginTop, paddingBottom: marginBottom, overflow: 'hidden', position: 'relative'}} >
                      {uiConfigs.gameBgMImage ?
                        <GetSlotBg
                          uiConfigs={this.props.uiConfigs}
                          columns={this.props.columns}
                          horizontalSpacing={marginStartEnd}
                        /> : null
                      }
                      <View style={{display: 'flex', height: slotViewHeight, width: slotViewWidth, overflow: 'hidden'}}>
                        <View
                          style={{
                            display: 'flex',
                            flex: 1,
                            marginBottom: - (rowsToHide/2 * boxSize),
                            marginTop: - (rowsToHide/2 * boxSize),
                            flexDirection: 'row'}}>
                          {<GetSlotViews
                            columnItems={this.columnItems}
                            cardSpacing={cardSpacing}
                            boxSize={cardSize}
                            animatedValues={this.state.animatedValues}
                            reset={this.state.reset}
                            onCardImageClicked={this.onCardImageClicked}
                            uiConfigs={this.props.uiConfigs}
                          />}
                        </View>
                      </View>
                    </View>
                    {uiConfigs.gameOverlayImage ?
                      <View style={{pointerEvents: 'none', position: 'absolute', left: isLTR ? -selectorBorderStartEnd : 0, right: !isLTR ? -selectorBorderStartEnd : 0, top: selectorViewTop, height: selectorViewHeight, width: viewWidth + 2 * selectorBorderStartEnd}}>
                        <ImageBackground source={uiConfigs.gameOverlayImage} style={{pointerEvents: 'none', height: selectorViewHeight, width: viewWidth + 2 * selectorBorderStartEnd}} />
                      </View>
                      : null
                    }
                  </View>
                  : this.getSingleRowSlotView(boxSize)}
                {!this.props.hideSpin ?
                    uiConfigs ?
                        <View style={{marginTop: uiConfigs.spinButtonMarginTop * sizeVFactor, alignItems: 'center', position: 'relative'}}>
                            <ImageBackground source={uiConfigs.playBgImage} style={{height: spinViewHeight, width: spinViewWidth, display: 'flex'}} >
                                <View style={{position: 'relative', height: '100%', width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', paddingLeft: 4 * sizeFactor, paddingRight: 4 * sizeFactor, opacity: this.props.spinsLeft > 0 ? 1 : 0.8}} >
                                    <View style={{display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'center', paddingBottom: uiConfigs.spinTextMarginBottom * sizeFactor, marginLeft: isLTR ? 0 : uiConfigs.spinTextMarginSide * sizeFactor, marginRight: !isLTR ? 0 : uiConfigs.spinTextMarginSide * sizeFactor}}>
                                        <AppText
                                            fontSizeN={uiConfigs.fontSize}
                                            align={'center'}
                                            color={uiConfigs.gameValueTextColor}
                                            fontWeight={FontWeightMedium}
                                            variant={'body1'}>
                                            {spinsLeftText}
                                        </AppText>
                                    </View>
                                    <AppImageButtonEx
                                        ref={this.handleRefSpin}
                                        disabled={!this.props.canSpin || !this.state.ideal}
                                        imageStyle={{width: spinButtonSize, height: spinButtonSize}}
                                        onClick={this.onSpinClicked}
                                        imageSource={uiConfigs.playImage} />
                                    <View style={{display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'center', paddingBottom: uiConfigs.spinTextMarginBottom * sizeFactor, marginLeft: !isLTR ? 0 : uiConfigs.spinTextMarginSide * sizeFactor, marginRight: isLTR ? 0 : uiConfigs.spinTextMarginSide * sizeFactor}}>
                                        <AppText
                                            fontSizeN={uiConfigs.fontSize}
                                            align={'center'}
                                            color={uiConfigs.gameValueTextColor}
                                            fontWeight={FontWeightMedium}
                                            variant={'body1'}>
                                            {locString('spinsLeft')}
                                        </AppText>
                                    </View>
                                </View>
                            </ImageBackground>

                            {this.state.delay ?
                                <View style={{position: 'absolute', top: 0, left: 0, right: 0, height: spinViewHeight, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                  <CircularProgress style={{color: uiConfigs.businessTitleColor}} />
                                </View>
                                : null
                            }
                        </View>
                        :
                        <View style={{position: 'relative'}}>
                            <Button
                                disabled={!this.props.canSpin || !this.state.ideal}
                                onClick={this.onSpinClicked}
                                titleColor={ColorWhite}
                                color={ColorTheme}
                                style={{width: boxSize * this.columns + 2, marginBottom: 4}}>
                              {locString('spin')}</Button>
                            {this.state.delay ?
                                <View style={{position: 'absolute', top: 0, left: 0, right: 0, height: HeightElementMinimum, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                  <CircularProgress style={{color: ColorTheme}} />
                                </View>
                                : null
                            }
                        </View>
                    : null
                }
            </View>
        );
    }

    handleRefSpin = (ref) => {
      this.refSpin = ref;
    }

    getSingleRowSlotView = (boxSize) => {
        const singleRowExtraSpace = 0;
        return (
            <View style={{overflow: 'hidden', height: boxSize + singleRowExtraSpace * 2, marginBottom: SpaceSmall, marginLeft: SpaceXSmall, marginRight: SpaceXSmall, borderRadius: RadiusView}}>
                <View
                    style={{
                        marginBottom: - (boxSize - singleRowExtraSpace),
                        marginTop: - (boxSize - singleRowExtraSpace),
                        borderRadius: RadiusView,
                        display: 'flex',
                        flexDirection: 'row',
                        height: boxSize * ROWS,
                        width: boxSize * this.columns + 2}}>
                    {<GetSlotViews
                      columnItems={this.columnItems}
                      cardSpacing={this.getCardSpacing()}
                      boxSize={this.getCardSize()}
                      animatedValues={this.state.animatedValues}
                      reset={this.state.reset}
                      onCardImageClicked={this.onCardImageClicked}
                      uiConfigs={this.props.uiConfigs}
                    />}
                </View>
            </View>
        );
    }

    getSlotBg = (horizontalSpacing) => {
        let views = [];
        for (let i = 0; i < this.props.columns; i++) {
            let marginStart = i > 0 ? (this.props.uiConfigs.slotBgSpacing || 0) : 0;
            marginStart *= this.props.uiConfigs.sizeFactor;
            views.push(
                <ImageBackground
                    key={'ib'+ i}
                    source={this.props.uiConfigs.gameBgMImage}
                    resizeMode="fill"
                    style={{display: 'flex', flex: 1, marginLeft: marginStart, borderWidth: 0}}/>
            )
        }
        return (
            <View style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: horizontalSpacing,
                right: horizontalSpacing,
                display: 'flex',
                flexDirection: 'row',
            }}>
                {views}
            </View>
        );
    }

    isStopping = (column) => {
        return this.endItems && this.stoppingCounters[column] === ROLL_STOPPING_COUNTER;
    }

    isStopped = (column) => {
        return this.endItems && this.stoppingCounters[column] > ROLL_STOPPING_COUNTER;
    }

    onSpinClicked = () => {
      if (this.props.noActionMode) {
        this.props.onActionClickedInNoActionMode();
        return;
      }

      // this.gameAudioPlayer.unmute();
      this.start();
      if (this.props.onSpinStarted) {
          this.props.onSpinStarted();
      }
    };

    onAnimationColumnFinished = (column, result) => {
        if (result.finished) {
            if (this.isStopped(column)) {
                this.playGameEndAudio(column);
                this.columnStoppedCounter++;
                if (this.columnStoppedCounter === this.columns) {
                    this.spinStopped();
                }
            } else {
                this.animationColumns[column].reset();
                this.animateColumn(column);
                if (this.endItems) {
                    this.stoppingCounters[column] = this.stoppingCounters[column] + 1;
                }
            }
        }
    }

    spinStopped = () => {
        this.stopGamePlayAudioAfterStop();
        if (this.processWin) {
            const delay = this.isWin ? 800 : SLOT_GAME_END_DELAY_MS;
            if (this.isWin) {
                this.isWin = false;
                this.playGameWinAudio();
            } else {
                this.playGameLoseAudio();
            }
            // Vibration.vibrate(200);

            setTimeout(() => {
                this.setState({ideal: true, delay: false});
                if (this.props.onSpinStopped) {
                    this.props.onSpinStopped();
                }
            }, delay);
        } else {
            if (this.props.onSpinStopped) {
                this.props.onSpinStopped();
            }
            setTimeout(() => {
                this.setState({ideal: true, delay: false});
            }, SLOT_GAME_END_DELAY_MS);
        }
    }

    animateColumn = (column) => {
        let index = this.columnItemsLength - ROWS;
        let duration = ANIMATION_DURATION + ANIMATION_DURATION * this.stoppingCounters[column];
        let easing = easings.linear;
        if (this.isStopping(column)) {
            index = this.getIndexToStop(this.columnItems[column], column);
            duration = ANIMATION_DURATION_STOP;
            easing = easings.easeOutSine;
        }

        this.state.animatedValues[column].set(0);
        const animationColumn = this.state.animatedValues[column].update({
          config: {
            easing: easing,
            duration: duration,
          },
          duration: duration,
          from: 0,
          to: -(this.getCardSize() * index),
          onRest: (result) => {
            // this.onAnimationColumnFinished(column, result);
          }
        });

        if (this.animationColumns.length > column) {
          this.animationColumns[column] = animationColumn;
        } else {
          this.animationColumns.push(animationColumn);
        }
        animationColumn.start().then(this.onAnimationStopped.bind(this, column));
    }

    onAnimationStopped = (column, result) => {
      this.onAnimationColumnFinished(column, result);
    };

    processChildItems = (childItems, forwardBy = 0, shuffle = false) => {
        let items = [];
        this.items.forEach((item) => {
            items.push(item);
        });
        if (forwardBy >= 0) {
            items = utils.slideForwardArray(items, forwardBy);
        } else if (forwardBy < 0) {
            items = utils.slideReverseArray(items, -forwardBy);
        }
        if (shuffle) {
            items = utils.shuffleArray(items);
        }
        items.forEach((item) => {
            const itemClone = utils.clone(item);
            itemClone.key = ''+ ++this.key;
            childItems.push(itemClone);
        });
        this.processDuplicates(childItems, ROWS);
    }

    processDuplicates = (childItems, count) => {
        let index = 0;
        const length = childItems.length;
        childItems.forEach((item) => {
            if (index < count) {
                const itemClone = utils.clone(item);
                itemClone.key = ''+ ++this.key;
                childItems.push(itemClone);
            }
            index++;
        });
        if (childItems.length < length + count) {
            this.processDuplicates(childItems, length + count - childItems.length);
        }
    }

    getIndexToStop = (columnItems, column) => {
        const endpointId = this.endItems.length > column ? this.endItems[column].id : columnItems[0].id;
        for (let i = 1; i < columnItems.length; i++) {
            if (columnItems[i].id === endpointId) {
                return i - 1;
            }
        }
    }

    getColumnView = (columnItems, boxSize) => {
        // const views = [];
        // columnItems.forEach((item) => {
        //     views.push(this.getView(item, boxSize));
        // });
        return (
            <View style={{width: boxSize}}>
                {columnItems.map((item) => <GetView item={item} boxSize={boxSize} uiConfigs={this.props.uiConfigs} onCardImageClicked={this.onCardImageClicked}/>)}
            </View>
        );
    };

    onCardImageClicked = (imageUrl) => {
        this.onImageClicked(imageUrl)
    };

    getCardSize = () => {
        if (this.props.cardSize) {
            return this.props.cardSize;
        }
        const uiConfigs = this.props.uiConfigs;
        const sizeFactor = uiConfigs.sizeFactor;
        const cardSpacing = this.getCardSpacing();

        const rows = this.props.rows;
        const columns = this.props.columns; // putting minimum columns to 4 to get correct card size
        const slotMarginStartEnd = uiConfigs ? uiConfigs.slotMarginStartEnd : 25;
        const slotMarginTop = uiConfigs ? uiConfigs.slotMarginTop : 0;
        const slotMarginBottom = uiConfigs ? uiConfigs.slotMarginBottom : 0;
        const otherUiHeight = 160 * sizeFactor;

        const possibleWidth = (this.props.contentWidth - 8 - (2 * slotMarginStartEnd * sizeFactor) - (columns - 1) * cardSpacing) / columns; // viewMargin, borderWidth, margin to each card
        const possibleHeight = (this.props.contentHeight - otherUiHeight - 8 - (slotMarginTop * sizeFactor + slotMarginBottom * sizeFactor) - (rows - 1) * cardSpacing) / rows; // viewMargin, borderWidth, margin to each card
        const possibleSize = Math.min(possibleWidth, possibleHeight);
        const maxCardSize = this.props.maxCardSize || 200;
        const cardSize = Math.floor(Math.min(maxCardSize, possibleSize));
        return cardSize;
    }

    getCardSpacing = () => {
        const slotSpacing = this.props.uiConfigs ? this.props.uiConfigs.slotSpacing : 2;
        return slotSpacing * this.props.uiConfigs.sizeFactor;
    }
}
